import { BaseView } from '../../../shared/utils/baseComponent'
import template from './activate.component.pug'
import css from './activate.component.scss'

class ActivateAccountController extends BaseView {
  constructor($element, SessionService, $state, $http, $q, $stateParams, $timeout, $mdToast, $cookies) {
    'ngInject'
    super($element)
    Object.assign(
      this,
      { SessionService, $state, $http, $q, $stateParams, $timeout, $mdToast, $cookies },
      {
        account: {},
        passwordMinLength: 8,
        nameMinLength: 2,
      },
    )
  }

  $onInit() {
    if (!this.cookie) this.$state.go('login')
  }

  onChangePasswordRepeat() {
    this.accountFrm.passwordRepeat.$setValidity('match', this.account.password === this.passwordRepeat)
  }

  activateAccount() {
    // Get credentials from cookie
    const token = this.cookie.token
    const email = this.cookie.email

    // Assign it to API call
    const accountData = Object.assign({}, this.account, { token, email })
    accountData.phone = accountData.phone || null

    // Activate user
    return this.$http({
      method: 'PATCH',
      url: '/api/users/activate',
      data: accountData,
    })
      .then(() => {
        const password = accountData.password

        // After activation, send automatic session call to log in
        return this.SessionService.authenticateByCredentials({ email, password }).then((user) => {
          this.$state.go('customers.customer.tasksites', { customerId: user.customers[0].customer.no }).then(() => {
            this.$timeout(() => {
              this.$cookies.remove('umsema')
              this.$mdToast.show(
                this.$mdToast
                  .simple()
                  .textContent('Ihr Benutzerkonto wurde erfolgreich aktiviert.')
                  .action('OK')
                  .position('bottom')
                  .hideDelay(10000),
              )
            }, 300)
          })
        })
      })
      .catch((err) => {
        console.error('err', err)
      })
  }
}

export const activateAccountComponent = {
  controller: ActivateAccountController,
  bindings: {
    cookie: '<',
  },
  template: template({ css }),
}



// WEBPACK FOOTER //
// ./app/account/containers/activate/activate.component.js